import Fish1 from "./../../Assets/images/Meat&Fish/Fish_1.webp";
// import Fish2 from "./../../Assets/images/Meat&Fish/Fish_2.png";
import Meat2 from "./../../Assets/images/Meat&Fish/meat_2.png";
import Meat3 from "./../../Assets/images/Meat&Fish/meat_3.webp";


const meatData = [
    {
        id: 1311,
        title: "Fish1",
        img: Fish1,
        price: 300,
        rating: 4,
      },
      {
        id: 1312,
        title: "Meat3",
        img: Meat3,
        price: 370,
        rating: 5,
      },
      {
        id: 1313,
        title: "Meat2",
        img: Meat2,
        price: 350,
        rating: 5,
      },
      {
        id: 1314,
        title: "Meat2",
        img: Meat2,
        price: 800,
        rating: 4,
      },
      {
        id: 1311,
        title: "Meat3",
        img: Meat3,
        price: 1200,
        rating: 5,
      },
      {
        id: 1311,
        title: "Fish1",
        img: Fish1,
        price: 300,
        rating: 4,
      },
]

export default meatData;